"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InjectComponents = void 0;
const gs = require("@ivanlog/gs");
const com = require("./tmpls");
const CmpBtnInfo_1 = require("./CmpBtnInfo");
const CmpHeader_1 = require("./CmpHeader");
const CmpHeroVX_1 = require("./CmpHeroVX");
const CmpInputTokenAmount_1 = require("./CmpInputTokenAmount");
const CmpModalDialog_1 = require("./CmpModalDialog");
const CmpRange_1 = require("./CmpRange");
const CmpWidgetVXApp_1 = require("./CmpWidgetVXApp");
const CmpWidgetVXSApp_1 = require("./CmpWidgetVXSApp");
const CmpWidgetVXStatus_1 = require("./CmpWidgetVXStatus");
const InjectComponents = () => { };
exports.InjectComponents = InjectComponents;
gs.WrapperGS.InjectComponents(CmpBtnInfo_1.CmpBtnInfo, 'cmpBtnInfo');
gs.WrapperGS.InjectComponents(com.CmpBtnWithTag, 'cmpBtnWithTag');
gs.WrapperGS.InjectComponents(com.CmpFooter, 'cmpFooter');
gs.WrapperGS.InjectComponents(com.CmpFormItemAddressPath, 'cmpFormItemAddressPath');
gs.WrapperGS.InjectComponents(CmpHeader_1.CmpHeader, 'cmpHeader');
gs.WrapperGS.InjectComponents(CmpHeroVX_1.CmpHeroVX, 'cmpHeroVX');
gs.WrapperGS.InjectComponents(com.CmpInfo3Steps, 'cmpInfo3Steps');
gs.WrapperGS.InjectComponents(CmpInputTokenAmount_1.CmpInputTokenAmount, 'cmpInputTokenAmount');
gs.WrapperGS.InjectComponents(com.CmpInputTokensSwap, 'cmpInputTokensSwap');
gs.WrapperGS.InjectComponents(CmpModalDialog_1.CmpModalDialog, 'cmpModalDialog');
gs.WrapperGS.InjectComponents(com.CmpPriceRange, 'cmpPriceRange');
gs.WrapperGS.InjectComponents(CmpRange_1.CmpRange, 'cmpRange');
gs.WrapperGS.InjectComponents(com.CmpSearch, 'cmpSearch');
gs.WrapperGS.InjectComponents(com.CmpTableListHeaderShort, 'cmpTableListHeaderShort');
gs.WrapperGS.InjectComponents(com.CmpTableListItemShort, 'cmpTableListItemShort');
gs.WrapperGS.InjectComponents(com.CmpWidgetDetails, 'cmpWidgetDetails');
gs.WrapperGS.InjectComponents(com.CmpWidgetInfoLPX, 'cmpWidgetInfoLPX');
gs.WrapperGS.InjectComponents(com.CmpWidgetInfoSV, 'cmpWidgetInfoSV');
gs.WrapperGS.InjectComponents(com.CmpWidgetInfoVX, 'cmpWidgetInfoVX');
gs.WrapperGS.InjectComponents(com.CmpWidgetInfoVXS, 'cmpWidgetInfoVXS');
gs.WrapperGS.InjectComponents(com.CmpWidgetTabTable, 'cmpWidgetTabTable');
gs.WrapperGS.InjectComponents(CmpWidgetVXApp_1.CmpWidgetVXApp, 'cmpWidgetVXApp');
gs.WrapperGS.InjectComponents(CmpWidgetVXSApp_1.CmpWidgetVXSApp, 'cmpWidgetVXSApp');
gs.WrapperGS.InjectComponents(CmpWidgetVXStatus_1.CmpWidgetVXStatus, 'cmpWidgetVXStatus');
gs.WrapperGS.InjectComponents(com.LayoutMain, 'layoutMain');
gs.WrapperGS.InjectComponents(com.PageLoading, 'pageLoading');
gs.WrapperGS.InjectComponents(com.PageVX, 'pageVX');
//# sourceMappingURL=tmplsInj.js.map